/**
 * Cohorts an A/B test can allocate users to. `control` is the baseline, the numbered ones
 * are the variants. Single source of truth for both the cohort name type and for listing
 * every selectable cohort.
 */
export const All_COHORTS = ['control', '1', '2', '3', '4', '5', '6', '7'] as const;

export type CohortNames = (typeof All_COHORTS)[number];
